import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const ProspectMetricsFieldsFragmentDoc = gql`
  fragment ProspectMetricsFields on ProspectMetrics {
    average_conversion_days
    conversion_rate
    converted_weekly_estimated_value_in_micros
    note_count
  }
`;
export const SalesPortalManagerRepSummariesDocument = gql`
  query SalesPortalManagerRepSummaries(
    $businessOrganizationUUID: uuid!
    $userTimezone: String!
  ) {
    getSalesPortalManagerRepSummaries(
      business_organization_id: $businessOrganizationUUID
      user_timezone: $userTimezone
    ) {
      currency_code
      employee_id
      employee_name
      uuid: employee_id
      mtd {
        ...ProspectMetricsFields
      }
      wtd {
        ...ProspectMetricsFields
      }
      ytd {
        ...ProspectMetricsFields
      }
    }
  }
  ${ProspectMetricsFieldsFragmentDoc}
`;
export function useSalesPortalManagerRepSummariesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >(SalesPortalManagerRepSummariesDocument, options);
}
export function useSalesPortalManagerRepSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >(SalesPortalManagerRepSummariesDocument, options);
}
export type SalesPortalManagerRepSummariesQueryHookResult = ReturnType<
  typeof useSalesPortalManagerRepSummariesQuery
>;
export type SalesPortalManagerRepSummariesLazyQueryHookResult = ReturnType<
  typeof useSalesPortalManagerRepSummariesLazyQuery
>;
export type SalesPortalManagerRepSummariesQueryResult = Apollo.QueryResult<
  Types.SalesPortalManagerRepSummariesQuery,
  Types.SalesPortalManagerRepSummariesQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalManagerRepSummariesQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalManagerRepSummariesQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >(SalesPortalManagerRepSummariesDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalManagerRepSummariesLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalManagerRepSummariesLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalManagerRepSummariesQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalManagerRepSummariesQuery,
    Types.SalesPortalManagerRepSummariesQueryVariables
  >(SalesPortalManagerRepSummariesDocument, lazyOptions);
}
